import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Autoscroll to element with ID if coming from a different page and URL has fragment
 * @param delay - in milliseconds before scrolling
 * @param offset - custom offset correction
 */
type UseInitialAutoscrollToFragmentProps = {
  delay?: number;
  offset?: number;
};

type UseInitialAutoscrollToFragment = (
  props?: UseInitialAutoscrollToFragmentProps,
) => void;

export const useInitialAutoscrollToFragment: UseInitialAutoscrollToFragment = (
  { delay, offset } = {
    delay: 0,
    offset: 0,
  },
) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));

      if (element) {
        setTimeout(() => {
          window.scrollTo({
            top: element.offsetTop + (offset ?? 0),
            behavior: "smooth",
          });
        }, delay ?? 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
